import { useEffect } from 'react';
import {
  hasTier1PrerenderInDocument,
  shouldSkipClientStructuredDataSchema,
} from '@/lib/seo/structured-data-prerender-guard';

type SchemaType = object;

export const useStructuredData = (schema: SchemaType | SchemaType[]) => {
  useEffect(() => {
    const hasPrerender = hasTier1PrerenderInDocument();
    const schemas = (Array.isArray(schema) ? schema : [schema]).filter(
      s => !shouldSkipClientStructuredDataSchema(s, hasPrerender)
    );

    if (schemas.length === 0) {
      return;
    }

    const scriptElements: HTMLScriptElement[] = [];

    schemas.forEach(s => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(s);
      document.head.appendChild(script);
      scriptElements.push(script);
    });

    return () => {
      scriptElements.forEach(script => {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      });
    };
  }, [JSON.stringify(schema)]);
};
